import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
// @material-ui/core components
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  Fab,
  FormControlLabel,
  IconButton,
  makeStyles,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  useTheme,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateUtils from "@date-io/moment";
import moment from "moment";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import {
  CreateChallanAPI,
  GetAllAccountsAPI,
  GetAllFittingMastersAPI,
  GetAllOrdersAPI,
  GetAllReadyMastersAPI,
  UpdateChallanAPI,
  UpdateCreditAPI,
  UpdateDebitAPI,
  GetAllReadyMastersCodesAPI,
  GetChallanAPI,
  CheckQuantity,
} from "../../config/api";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSelector } from "react-redux";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { toast } from "react-toastify";
import { ChallanOrdersDialog } from "./ChallanOrdersDialog.js";
import { ColorsDialog } from "./ColorsDialog.js";

const filterOptions = createFilterOptions({
  matchFrom: "any",
  limit: 500,
});

const useStyles = makeStyles((theme) => ({
  fab: {
    marginTop: 26,
  },
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
}));

let columns = [
  { id: "codeR", label: "Code R" },
  { id: "codeL", label: "Code L" },
  { id: "nameR", label: "Name R" },
  { id: "nameL", label: "Name L" },
  { id: "quantity", label: "Quantity" },
  { id: "rateR", label: "Rate R" },
  { id: "rateL", label: "Rate L" },
  { id: "rate", label: "Rate" },
  {
    id: "discountAmount",
    label: "Discount Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "discountPercent", label: "Discount Percent" },
  { id: "fitting", label: "Fitting" },
  {
    id: "fittingAmount",
    label: "Fitting Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "tint", label: "Tint" },
  // { id: "arc", label: "Arc" },
  {
    id: "amount",
    label: "Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "orderRef", label: "Order Ref" },
  { id: "action", label: "Action" },
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function ChallanEditDialog(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { open, close, item, source, showPrintModal, readyMasterRange } = props;

  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);

  const [users, setUsers] = useState([]);
  const [readyMasters, setReadyMasters] = useState([]);
  const [party, setParty] = useState(item?.party || null);
  const [codeL, setCodeL] = useState(null);
  const [codeR, setCodeR] = useState(null);
  const [isPrescriptionOrderMode, setIsPrescriptionOrderMode] = useState(false);
  const [nameL, setNameL] = useState("");
  const [nameR, setNameR] = useState("");
  const [brandR, setBrandR] = useState("");
  const [brandL, setBrandL] = useState("");
  const [lProductCode, setLProductCode] = useState("");
  const [rProductCode, setRProductCode] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rateR, setRateR] = useState("");
  const [rateL, setRateL] = useState("");
  const [rate, setRate] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [discountPercent, setDiscountPercent] = useState(0);
  const [fitting, setFitting] = useState("");
  const [fittingAmount, setFittingAmount] = useState("");
  const [tint, setTint] = useState("");
  const [arc, setArc] = useState("");
  const [amount, setAmount] = useState("");
  const [orderRef, setOrderRef] = useState("");
  const [packagingCost, setPackagingCost] = useState("");
  const [packagingTaxPercent, setPackagingTaxPercent] = useState("5");
  const [items, setItems] = useState(item?.items || []);
  const [orders, setOrders] = useState([]);
  const [codes, setCodes] = useState([]);
  const [codesL, setCodesL] = useState([]);
  const [codesR, setCodesR] = useState([]);
  const [fittingMasters, setFittingMasters] = useState([]);
  const [fittingMastersCodes, setFittingMastersCodes] = useState([]);
  const [coating, setCoating] = useState("");
  const [hsnCode, setHsnCode] = useState("");
  const [taxPercent, setTaxPercent] = useState("5");
  const [openOrdersDialog, setOpenOrdersDialog] = useState(false);
  const [openColorsDialog, setOpenColorsDialog] = useState(false);
  const [challanDate, setChallanDate] = useState(null);
  const [selectR, setSelectR] = useState({});
  const [selectL, setSelectL] = useState({});
  const [reverseEntry, setReverseEntry] = useState(false);
  const [isSavingChallan, setIsSavingChallan] = useState(false);
  const [loadingFittingMasters, setLoadingFittingMasters] = useState(false);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [loadingCodesR, setLoadingCodesR] = useState(false);
  const [loadingCodesL, setLoadingCodesL] = useState(false);
  const [lSph, setLsph] = useState("");
  const [rSph, setRsph] = useState("");
  const [lCyl, setLcyl] = useState("");
  const [rCyl, setRcyl] = useState("");
  const [rAxis, setRaxis] = useState("");
  const [lAxis, setLaxis] = useState("");
  const [lAdd, setLadd] = useState("");
  const [rAdd, setRadd] = useState("");
  const codeRRef = useRef(codeR);
  const codeLRef = useRef(codeL);

  // Refs for request cancellation
  const fittingAbortControllerRef = useRef(null);
  const ordersAbortControllerRef = useRef(null);
  const codesRAbortControllerRef = useRef(null);
  const codesLAbortControllerRef = useRef(null);

  // Cache for orders by party ID
  const ordersCacheRef = useRef(new Map());

  // Refs to store debounced functions for cleanup
  const debouncedEffectRef = useRef(null);
  const debouncedEffectLRef = useRef(null);

  // LocalStorage cache for fitting masters (entity-specific, rarely changes)
  const fittingMastersCacheKey = `fittingMasters_${userInfo?.entity}`;

  // Client-side cache for codes API results
  const codesCacheRef = useRef(new Map());
  const CACHE_TTL = 15 * 60 * 1000; // 15 minutes

  const getCodesCacheKey = useCallback((entity, productCode, side) => {
    return `${entity}_${productCode}_${side}`;
  }, []);

  const getCachedCodes = useCallback(
    (entity, productCode, side) => {
      const exactKey = getCodesCacheKey(entity, productCode, side);
      const exactCached = codesCacheRef.current.get(exactKey);
      if (exactCached && Date.now() - exactCached.timestamp < CACHE_TTL) {
        return exactCached.data;
      }

      // Prefix match: allow using cached shorter searches for longer searches
      for (let i = productCode.length - 1; i >= 3; i--) {
        const prefix = productCode.substring(0, i);
        const prefixKey = getCodesCacheKey(entity, prefix, side);
        const prefixCached = codesCacheRef.current.get(prefixKey);
        if (prefixCached && Date.now() - prefixCached.timestamp < CACHE_TTL) {
          const filtered = prefixCached.data.filter(
            (code) =>
              code.productCode &&
              code.productCode.toLowerCase().startsWith(productCode.toLowerCase())
          );
          if (filtered.length > 0) return filtered;
        }
      }
      return null;
    },
    [getCodesCacheKey]
  );

  const setCachedCodes = useCallback(
    (entity, productCode, side, data) => {
      const key = getCodesCacheKey(entity, productCode, side);
      codesCacheRef.current.set(key, { data, timestamp: Date.now() });
    },
    [getCodesCacheKey]
  );

  // Sync refs
  useEffect(() => {
    codeRRef.current = codeR;
  }, [codeR]);
  useEffect(() => {
    codeLRef.current = codeL;
  }, [codeL]);

  // Init from item when dialog opens. Fetch full challan so we always have line items (list API may not return items).
  useEffect(() => {
    if (!open || !item) return;
    const initFromItem = (challan) => {
      setChallanDate(challan.challanDate ? moment(challan.challanDate) : (challan.createdAt ? moment(challan.createdAt) : null));
      setPackagingCost(challan.packagingCost != null ? String(challan.packagingCost) : "");
      const rawPkgTax = challan.packagingTaxPercent;
      const pkgTaxBlank =
        rawPkgTax == null ||
        (typeof rawPkgTax === "string" && String(rawPkgTax).trim() === "");
      setPackagingTaxPercent(pkgTaxBlank ? "5" : String(rawPkgTax));
      setTaxPercent("5");
      const nextItems = (challan.items && Array.isArray(challan.items) ? challan.items : []).map(
        (it) => ({
          ...it,
          taxPercent: 5,
          packagingTaxPercent: 5,
        })
      );
      setItems(nextItems);

      // Auto-detect saved "Prescription Order" challans and show correct mode in Edit.
      // We support both shapes:
      // - challan.isPrescriptionOrder (if backend stores it on challan)
      // - item.isPrescriptionOrder (if stored per line-item)
      const isPrescription =
        Boolean(challan?.isPrescriptionOrder) ||
        nextItems.some((it) => Boolean(it?.isPrescriptionOrder));
      setIsPrescriptionOrderMode(isPrescription);
    };
    // If list already provided items, use them
    if (item.items && Array.isArray(item.items) && item.items.length > 0) {
      initFromItem(item);
      return;
    }
    // Otherwise fetch full challan by ID so we have line items
    let cancelled = false;
    axios
      .get(GetChallanAPI(item._id), {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (cancelled) return;
        const full = res.data?.challan || res.data;
        initFromItem(full);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("Failed to load challan for edit:", err);
        toast.error("Could not load challan details. Using list data.");
        initFromItem(item);
      });
    return () => { cancelled = true; };
  }, [open, item?._id, authToken]);

  // Cleanup when clearing code R/L (match Add)
  const cleanupCodeR = useCallback(() => {
    setNameR("");
    setRateR("");
    setRProductCode("");
    setRsph("");
    setRcyl("");
    setRaxis("");
    setRadd("");
    setBrandR("");
    if (!codeL) {
      setQuantity("");
      setFittingAmount("");
      setFitting("");
      setOrderRef("");
      setRate("");
      setHsnCode("");
      setTaxPercent("");
      setPackagingTaxPercent("");
      setDiscountPercent(0);
      setCoating("");
    } else {
      if (rateL) setRate(rateL.toString());
      else setRate("");
    }
  }, [codeL, rateL]);
  const cleanupCodeL = useCallback(() => {
    setNameL("");
    setRateL("");
    setLProductCode("");
    setLsph("");
    setLcyl("");
    setLaxis("");
    setLadd("");
    setBrandL("");
    if (!codeR) {
      setQuantity("");
      setFittingAmount("");
      setFitting("");
      setOrderRef("");
      setRate("");
      setHsnCode("");
      setTaxPercent("");
      setPackagingTaxPercent("");
      setDiscountPercent(0);
      setCoating("");
    } else {
      if (rateR) setRate(rateR.toString());
      else setRate("");
    }
  }, [codeR, rateR]);

  // Memoized calculations
  const sumOfQuantities = useMemo(() => {
    return items.reduce((accumulator, currentValue) => {
      return Number(accumulator + Number(currentValue.quantity));
    }, 0);
  }, [items]);

  const sumOfAmounts = useMemo(() => {
    return items.reduce((accumulator, currentValue) => {
      return Number(accumulator + Number(currentValue.amount));
    }, 0);
  }, [items]);

  // Memoized codes from orders
  const orderCodes = useMemo(() => {
    return orders.map((i) => i.code).filter(Boolean);
  }, [orders]);

  // Seed dropdown lists with order codes
  useEffect(() => {
    setCodes(orderCodes);
    setCodesR(orderCodes);
    setCodesL(orderCodes);
  }, [orderCodes]);

  useEffect(() => {
    _getUsers();
    _getFittingMasters();

    return () => {
      if (fittingAbortControllerRef.current) fittingAbortControllerRef.current.abort();
      if (ordersAbortControllerRef.current) ordersAbortControllerRef.current.abort();
      if (codesRAbortControllerRef.current) codesRAbortControllerRef.current.abort();
      if (codesLAbortControllerRef.current) codesLAbortControllerRef.current.abort();
      if (debouncedEffectRef.current) debouncedEffectRef.current.cancel();
      if (debouncedEffectLRef.current) debouncedEffectLRef.current.cancel();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    _getOrders();

    return () => {
      if (ordersAbortControllerRef.current) ordersAbortControllerRef.current.abort();
    };
  }, [party]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    console.log("afterR");
    if (selectR?.code) {
      debouncedEffect(selectR.code);
    }
    setCodeR(selectR.code);
  }, [selectR]);
  useEffect(() => {
    console.log("afterL");
    if (selectL?.code) {
      debouncedEffectL(selectL.code);
    }
    setCodeL(selectL.code);
  }, [selectL]);

  const resolveApplicableDiscount = (selectedItem) => {
    const discounts = (party?.discounts || []).slice().reverse();
    if (!discounts.length || !selectedItem) return null;

    const inputName = (selectedItem.productName || "").trim().toLowerCase();
    const inputCode = (selectedItem.productCode || "").trim();
    const inputColor = (selectedItem.color || "").trim().toLowerCase();

    let appliedDiscount = discounts.find((rule) => {
      if (rule.type !== "Range") return false;
      if (!rule.product) return false;

      const ruleName = (rule.product.productName || "").trim().toLowerCase();
      const nameMatch = ruleName === inputName;
      const codeMatch =
        rule.product.codeRanges?.some(
          (rangeCode) => String(rangeCode).trim() === inputCode
        ) ?? false;

      return nameMatch && codeMatch;
    });

    if (!appliedDiscount) {
      appliedDiscount = discounts.find((rule) => {
        const isColorRule = !rule.type || rule.type === "Color";
        if (!isColorRule) return false;
        if (!rule.product?.color || !inputColor) return false;

        return String(rule.product.color).trim().toLowerCase() === inputColor;
      });
    }

    return appliedDiscount || null;
  };

  const afterSelectR = useCallback((codeRVal) => {
    if (!codeRVal) return;
    let obj = null;

    if (orders?.length > 0) {
      obj = orders.find((o) => o.code === codeRVal) || null;
    }
    if (!obj && readyMasters?.length > 0) {
      obj = _.find(readyMasters, { productCode: codeRVal }) || null;
    }
    // Prefix cache lookup
    if (!obj && codeRVal?.length >= 5) {
      for (let len = codeRVal.length; len >= 5; len--) {
        const prefix = codeRVal.substring(0, len);
        const cached = getCachedCodes(userInfo.entity, prefix, "R");
        if (cached?.length) {
          const match = cached.find((it) => it.productCode === codeRVal);
          if (match) {
            obj = match;
            setReadyMasters(cached);
            break;
          }
        }
      }
    }
    if (!obj) return;

    if (obj.orderDetail) {
      setQuantity(obj.quantity);
      let productCode = "";
      if (obj.orderType === "Fitting") {
        if (obj.orderDetail.fitting) {
          setFitting(obj.orderDetail.fitting);
          const fit = _.find(fittingMasters, { fittingType: obj.orderDetail.fitting });
          if (fit) setFittingAmount(fit.amount);
        }
        setRateR(obj.orderDetail.rRate);
        productCode =
          obj.orderDetail.rSph + "/" + obj.orderDetail.rCyl + "/" + obj.orderDetail.rAxis + "/" + obj.orderDetail.rAddition;
        setNameR(
          [
            obj.orderDetail.product?.index ?? obj.orderDetail.fitter,
            obj.orderDetail.productName ?? obj.orderDetail.productNameR,
            obj.orderDetail.product?.coating ?? obj.orderDetail.fitting,
            productCode,
          ]
            .filter(Boolean)
            .join("-")
        );
      } else {
        setRateR(obj.rate);
        productCode =
          obj.orderDetail.rSph + "/" + obj.orderDetail.rCyl + "/" + obj.orderDetail.rAxis + "/" + obj.orderDetail.rAddition;
        if (obj.orderDetail.product) {
          setNameR(
            [obj.orderDetail.product.index, obj.orderDetail.product.productName, obj.orderDetail.product.coating, productCode]
              .filter(Boolean)
              .join("-")
          );
          if (obj.orderDetail.product.price !== undefined) setRateR(obj.orderDetail.product.price);
          else if (obj.rate !== undefined) setRateR(obj.rate);
          setHsnCode(obj.orderDetail.product.hsnCode);
          setTaxPercent(obj.orderDetail.product.taxPercent);
        } else {
          setNameR((obj.orderDetail.productName || "") + (productCode ? "-" + productCode : ""));
          if (obj.rate !== undefined && obj.price === undefined) setRateR(obj.rate);
        }
      }
      setOrderRef(obj.code);
      setRProductCode(productCode);
      setDiscountPercent(0);
      return;
    }

    if (obj.productName || obj.productCode) {
      const indexPart = obj.index ? `${obj.index}-` : "";
      setNameR(indexPart + (obj.productName || obj.productCode || ""));
      setBrandR(obj.brand);
      setRateR(obj?.rate);
      setRProductCode(obj?.productCode);
      setHsnCode(obj?.hsnCode);
      setTaxPercent(obj?.taxPercent);
      setRsph(obj?.sph);
      setRcyl(obj?.cyl);
      setRaxis(obj?.axis);
      setRadd(obj?.addition);

      const appliedDiscount = resolveApplicableDiscount(obj);
      if (appliedDiscount) {
        if (appliedDiscount.product?.productName) {
          setNameR(appliedDiscount.product.productName);
        }
        setDiscountPercent(appliedDiscount.discountPercent || 0);
      } else {
        setDiscountPercent(0);
      }
    }
  }, [orders, readyMasters, fittingMasters, party, userInfo.entity, getCachedCodes]);

  const afterSelectL = useCallback((codeLVal) => {
    if (!codeLVal) return;
    let obj = null;

    if (orders?.length > 0) {
      obj = orders.find((o) => o.code === codeLVal) || null;
    }
    if (!obj && readyMasters?.length > 0) {
      obj = _.find(readyMasters, { productCode: codeLVal }) || null;
    }
    // Prefix cache lookup
    if (!obj && codeLVal?.length >= 5) {
      for (let len = codeLVal.length; len >= 5; len--) {
        const prefix = codeLVal.substring(0, len);
        const cached = getCachedCodes(userInfo.entity, prefix, "L");
        if (cached?.length) {
          const match = cached.find((it) => it.productCode === codeLVal);
          if (match) {
            obj = match;
            setReadyMasters(cached);
            break;
          }
        }
      }
    }
    if (!obj) return;

    if (obj.orderDetail) {
      setQuantity(obj.quantity);
      let productCode = "";
      if (obj.orderType === "Fitting") {
        if (obj.orderDetail.fitting) {
          setFitting(obj.orderDetail.fitting);
          const fit = _.find(fittingMasters, { fittingType: obj.orderDetail.fitting });
          if (fit) setFittingAmount(fit.amount);
        }
        setRateL(obj.orderDetail.lRate);
        productCode =
          obj.orderDetail.lSph + "/" + obj.orderDetail.lCyl + "/" + obj.orderDetail.lAxis + "/" + obj.orderDetail.lAddition;
        setNameL(
          [
            obj.orderDetail.product?.index ?? obj.orderDetail.fitter,
            obj.orderDetail.productName ?? obj.orderDetail.productNameR,
            obj.orderDetail.product?.coating ?? obj.orderDetail.fitting,
            productCode,
          ]
            .filter(Boolean)
            .join("-")
        );
      } else {
        setRateL(obj.rate);
        productCode =
          obj.orderDetail.lSph + "/" + obj.orderDetail.lCyl + "/" + obj.orderDetail.lAxis + "/" + obj.orderDetail.lAddition;
        if (obj.orderDetail.product) {
          setNameL(
            [obj.orderDetail.product.index, obj.orderDetail.product.productName, obj.orderDetail.product.coating, productCode]
              .filter(Boolean)
              .join("-")
          );
          if (obj.orderDetail.product.price !== undefined) setRateL(obj.orderDetail.product.price);
          else if (obj.rate !== undefined) setRateL(obj.rate);
          setHsnCode(obj.orderDetail.product.hsnCode);
          setTaxPercent(obj.orderDetail.product.taxPercent);
        } else {
          setNameL((obj.orderDetail.productName || "") + (productCode ? "-" + productCode : ""));
          if (obj.rate !== undefined && obj.price === undefined) setRateL(obj.rate);
        }
      }
      setOrderRef(obj.code);
      setLProductCode(productCode);
      setDiscountPercent(0);
      return;
    }

    if (obj.productName || obj.productCode) {
      const indexPart = obj.index ? `${obj.index}-` : "";
      setNameL(indexPart + (obj.productName || obj.productCode || ""));
      setBrandL(obj.brand);
      setRateL(obj?.rate);
      setLProductCode(obj?.productCode);
      setHsnCode(obj?.hsnCode);
      setTaxPercent(obj?.taxPercent);
      setLsph(obj?.sph);
      setLcyl(obj?.cyl);
      setLaxis(obj?.axis);
      setLadd(obj?.addition);

      const appliedDiscount = resolveApplicableDiscount(obj);
      if (appliedDiscount) {
        if (appliedDiscount.product?.productName) {
          setNameL(appliedDiscount.product.productName);
        }
        setDiscountPercent(appliedDiscount.discountPercent || 0);
      } else {
        setDiscountPercent(0);
      }
    }
  }, [orders, readyMasters, fittingMasters, party, userInfo.entity, getCachedCodes]);

  const debouncedEffect = useMemo(() => {
    const debounced = _.debounce((codeRVal) => {
      let nextCodes = [...orderCodes];
      let nextCodesR = [...orderCodes];

      if (!codeRVal) return;
      if (codeRVal.length < 5) {
        // Still allow order codes list
        nextCodes.sort((a, b) => {
          const aStartsWithO = a.toLowerCase().startsWith("o");
          const bStartsWithO = b.toLowerCase().startsWith("o");
          if (aStartsWithO && !bStartsWithO) return 1;
          if (!aStartsWithO && bStartsWithO) return -1;
          return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
        });
        setCodes(nextCodes);
        return;
      }

      // Cache first
      const cached = getCachedCodes(userInfo.entity, codeRVal, "R");
      if (cached) {
        setReadyMasters(cached);
        const readyMasterCodes = cached.map((i) => i.productCode);
        const readyMasterCodesR = cached
          .filter((i) => i.side === "B" || i.side === "R")
          .map((i) => i.productCode);
        nextCodes = [...orderCodes, ...readyMasterCodes];
        nextCodesR = [...orderCodes, ...readyMasterCodesR];
        nextCodesR.sort((a, b) => {
          const aStartsWithO = a.toLowerCase().startsWith("o");
          const bStartsWithO = b.toLowerCase().startsWith("o");
          if (aStartsWithO && !bStartsWithO) return 1;
          if (!aStartsWithO && bStartsWithO) return -1;
          return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
        });
        nextCodes.sort((a, b) => {
          const aStartsWithO = a.toLowerCase().startsWith("o");
          const bStartsWithO = b.toLowerCase().startsWith("o");
          if (aStartsWithO && !bStartsWithO) return 1;
          if (!aStartsWithO && bStartsWithO) return -1;
          return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
        });
        setCodesR(nextCodesR);
        setCodes(nextCodes);
        return;
      }

      // Cancel previous request
      if (codesRAbortControllerRef.current) {
        codesRAbortControllerRef.current.abort();
      }
      codesRAbortControllerRef.current = new AbortController();

      setLoadingCodesR(true);
      axios
        .get(GetAllReadyMastersCodesAPI(userInfo.entity, codeRVal, "R"), {
          headers: { Authorization: `Bearer ${authToken}` },
          signal: codesRAbortControllerRef.current.signal,
        })
        .then((res) => {
          const readyMastersData = res.data.readyMasters || [];
          const limited = readyMastersData.slice(0, 200);
          setCachedCodes(userInfo.entity, codeRVal, "R", limited);
          setReadyMasters(limited);

          const readyMasterCodes = limited.map((i) => i.productCode);
          const readyMasterCodesR = limited
            .filter((i) => i.side === "B" || i.side === "R")
            .map((i) => i.productCode);

          nextCodes = [...orderCodes, ...readyMasterCodes];
          nextCodesR = [...orderCodes, ...readyMasterCodesR];

          nextCodesR.sort((a, b) => {
            const aStartsWithO = a.toLowerCase().startsWith("o");
            const bStartsWithO = b.toLowerCase().startsWith("o");
            if (aStartsWithO && !bStartsWithO) return 1;
            if (!aStartsWithO && bStartsWithO) return -1;
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
          });
          nextCodes.sort((a, b) => {
            const aStartsWithO = a.toLowerCase().startsWith("o");
            const bStartsWithO = b.toLowerCase().startsWith("o");
            if (aStartsWithO && !bStartsWithO) return 1;
            if (!aStartsWithO && bStartsWithO) return -1;
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
          });

          setCodesR(nextCodesR);
          setCodes(nextCodes);
        })
        .catch((e) => {
          if (e.name !== "AbortError" && e.code !== "ECONNABORTED") {
            // ignore noisy errors
          }
        })
        .finally(() => setLoadingCodesR(false));
    }, 500);
    debouncedEffectRef.current = debounced;
    return debounced;
  }, [orderCodes, orderCodes.length, orders, userInfo.entity, authToken, getCachedCodes, setCachedCodes]); // eslint-disable-line react-hooks/exhaustive-deps

  const debouncedEffectL = useMemo(() => {
    const debounced = _.debounce((codeLVal) => {
      let nextCodes = [...orderCodes];
      let nextCodesL = [...orderCodes];

      if (!codeLVal) return;
      if (codeLVal.length < 5) {
        nextCodes.sort((a, b) => {
          const aStartsWithO = a.toLowerCase().startsWith("o");
          const bStartsWithO = b.toLowerCase().startsWith("o");
          if (aStartsWithO && !bStartsWithO) return 1;
          if (!aStartsWithO && bStartsWithO) return -1;
          return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
        });
        setCodes(nextCodes);
        return;
      }

      const cached = getCachedCodes(userInfo.entity, codeLVal, "L");
      if (cached) {
        setReadyMasters(cached);
        const readyMasterCodes = cached.map((i) => i.productCode);
        const readyMasterCodesL = cached
          .filter((i) => i.side === "B" || i.side === "L")
          .map((i) => i.productCode);
        nextCodes = [...orderCodes, ...readyMasterCodes];
        nextCodesL = [...orderCodes, ...readyMasterCodesL];
        nextCodesL.sort((a, b) => {
          const aStartsWithO = a.toLowerCase().startsWith("o");
          const bStartsWithO = b.toLowerCase().startsWith("o");
          if (aStartsWithO && !bStartsWithO) return 1;
          if (!aStartsWithO && bStartsWithO) return -1;
          return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
        });
        nextCodes.sort((a, b) => {
          const aStartsWithO = a.toLowerCase().startsWith("o");
          const bStartsWithO = b.toLowerCase().startsWith("o");
          if (aStartsWithO && !bStartsWithO) return 1;
          if (!aStartsWithO && bStartsWithO) return -1;
          return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
        });
        setCodesL(nextCodesL);
        setCodes(nextCodes);
        return;
      }

      if (codesLAbortControllerRef.current) {
        codesLAbortControllerRef.current.abort();
      }
      codesLAbortControllerRef.current = new AbortController();

      setLoadingCodesL(true);
      axios
        .get(GetAllReadyMastersCodesAPI(userInfo.entity, codeLVal, "L"), {
          headers: { Authorization: `Bearer ${authToken}` },
          signal: codesLAbortControllerRef.current.signal,
        })
        .then((res) => {
          const readyMastersData = res.data.readyMasters || [];
          const limited = readyMastersData.slice(0, 200);
          setCachedCodes(userInfo.entity, codeLVal, "L", limited);
          setReadyMasters(limited);

          const readyMasterCodes = limited.map((i) => i.productCode);
          const readyMasterCodesL = limited
            .filter((i) => i.side === "B" || i.side === "L")
            .map((i) => i.productCode);

          nextCodes = [...orderCodes, ...readyMasterCodes];
          nextCodesL = [...orderCodes, ...readyMasterCodesL];

          nextCodesL.sort((a, b) => {
            const aStartsWithO = a.toLowerCase().startsWith("o");
            const bStartsWithO = b.toLowerCase().startsWith("o");
            if (aStartsWithO && !bStartsWithO) return 1;
            if (!aStartsWithO && bStartsWithO) return -1;
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
          });
          nextCodes.sort((a, b) => {
            const aStartsWithO = a.toLowerCase().startsWith("o");
            const bStartsWithO = b.toLowerCase().startsWith("o");
            if (aStartsWithO && !bStartsWithO) return 1;
            if (!aStartsWithO && bStartsWithO) return -1;
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
          });

          setCodesL(nextCodesL);
          setCodes(nextCodes);
        })
        .catch((e) => {
          if (e.name !== "AbortError" && e.code !== "ECONNABORTED") {
            // ignore noisy errors
          }
        })
        .finally(() => setLoadingCodesL(false));
    }, 500);
    debouncedEffectLRef.current = debounced;
    return debounced;
  }, [orderCodes, orderCodes.length, orders, userInfo.entity, authToken, getCachedCodes, setCachedCodes]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (discountAmount) {
      setDiscountPercent("");
    } else {
      setDiscountAmount("");
    }
  }, [discountAmount]);

  useEffect(() => {
    if (discountPercent) {
      setDiscountAmount("");
    } else {
      setDiscountPercent("");
    }
  }, [discountPercent]);

  useEffect(() => {
    if (rateR) {
      setRate(rateR.toString());
    }
    if (rateL) {
      setRate(rateL.toString());
    }
    if (rateR && rateL) {
      let rate = (Number(rateR) + Number(rateL)) / 2;
      setRate(rate.toString());
    }
  }, [rateR, rateL]);

  useEffect(() => {
    let amount = 0;
    if (rate && quantity) {
      amount = Number(rate) * Number(quantity);
    }
    if (discountAmount) {
      const qty = Number(quantity) || 0;
      const disPerUnit = Number(discountAmount) || 0;
      amount = amount - disPerUnit * qty;
    }
    if (discountPercent) {
      amount = amount - (amount * Number(discountPercent)) / 100;
    }
    if (fittingAmount && quantity) {
      amount += Number(fittingAmount) * Number(quantity);
    }
    if (tint && quantity) {
      amount += Number(quantity) * Number(tint);
    }
    setAmount(amount.toFixed(2));
  }, [rate, fittingAmount, discountAmount, discountPercent, tint, quantity]);

  useEffect(() => {
    let obj = _.find(fittingMasters, { fittingType: fitting });
    if (obj) {
      setFittingAmount(obj.amount);
    }
  }, [fitting]);

  async function _getFittingMasters() {
    // Try localStorage cache first (1 hour)
    try {
      const cached = localStorage.getItem(fittingMastersCacheKey);
      if (cached) {
        const cachedData = JSON.parse(cached);
        const cacheAge = Date.now() - cachedData.timestamp;
        if (cacheAge < 3600000) {
          setFittingMasters(cachedData.fittingMasters || []);
          setFittingMastersCodes(cachedData.fittingMastersCodes || []);
          return;
        }
      }
    } catch (e) {
      // ignore cache errors
    }

    if (fittingAbortControllerRef.current) {
      fittingAbortControllerRef.current.abort();
    }
    fittingAbortControllerRef.current = new AbortController();

    setLoadingFittingMasters(true);
    try {
      const res = await axios.get(GetAllFittingMastersAPI(userInfo.entity), {
        headers: { Authorization: `Bearer ${authToken}` },
        signal: fittingAbortControllerRef.current.signal,
      });
      const masters = res.data.fittingMasters || [];
      const masterCodes = masters.map((i) => i.fittingType).filter(Boolean);
      setFittingMasters(masters);
      setFittingMastersCodes(masterCodes);
      try {
        localStorage.setItem(
          fittingMastersCacheKey,
          JSON.stringify({
            fittingMasters: masters,
            fittingMastersCodes: masterCodes,
            timestamp: Date.now(),
          })
        );
      } catch (e) {
        // ignore cache write errors
      }
    } catch (err) {
      if (err.name === "AbortError" || err.code === "ECONNABORTED") return;
    } finally {
      setLoadingFittingMasters(false);
    }
  }

  async function _getUsers() {
    try {
      let res = await axios.get(GetAllAccountsAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setUsers(res.data.accounts);

      // Handle the case where item.party might be undefined or null
      if (item?.party) {
        let foundParty = null;

        // Try to find the party by accountId (preferred method)
        if (item.party.accountId) {
          foundParty = _.find(res.data.accounts, { _id: item.party.accountId });
        }

        // If not found by accountId, try by _id
        if (!foundParty && item.party._id) {
          foundParty = _.find(res.data.accounts, { _id: item.party._id });
        }

        // If not found by ID, try by accountName
        if (!foundParty && item.party.accountName) {
          foundParty = _.find(res.data.accounts, { name: item.party.accountName });
        }

        // Set the found party or create a hybrid object
        if (foundParty) {
          setParty(foundParty);
        } else {
          // Create a hybrid object that works with both Autocomplete and orders fetch
          const hybridParty = {
            ...item.party,
            name: item.party.accountName || item.party.name || "Unknown Party",
            _id: item.party.accountId || item.party._id,
          };
          setParty(hybridParty);
          console.warn("Party not found in accounts list, using hybrid object:", hybridParty);
        }
      }
    } catch (e) {
      console.error("Error fetching users:", e);
    }
  }

  async function _getOrders() {
    try {
      // Get party ID from either _id or accountId
      const partyId = party?._id || party?.accountId;

      if (!party || !partyId) {
        setOrders([]);
        return;
      }

      const cacheKey = `orders_${partyId}`;
      const cached = ordersCacheRef.current.get(cacheKey);
      if (cached) {
        setOrders(cached);
        return;
      }

      if (ordersAbortControllerRef.current) {
        ordersAbortControllerRef.current.abort();
      }
      ordersAbortControllerRef.current = new AbortController();

      setLoadingOrders(true);
      const res = await axios.get(
        GetAllOrdersAPI(userInfo.entity) +
          `&userId=${partyId}&isChallanCreated=false&orderAdminStatus=Confirmed&orderStatus=Completed&pagination=false`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
          signal: ordersAbortControllerRef.current.signal,
        }
      );
      const sortedOrders = (res.data.orders || []).slice().sort((a, b) => {
        const dateA = new Date(a.updatedAt || a.createdAt || a._id);
        const dateB = new Date(b.updatedAt || b.createdAt || b._id);
        return dateB - dateA;
      });
      setOrders(sortedOrders);
      ordersCacheRef.current.set(cacheKey, sortedOrders);
    } catch (err) {
      if (err.name === "AbortError" || err.code === "ECONNABORTED") return;
      console.error("Error fetching orders:", err);
    } finally {
      setLoadingOrders(false);
    }
  }

  async function _onSave(print) {
    if (isSavingChallan) return;
    try {
      let totalAmount = 0;
      _.forEach(items, (i) => {
        totalAmount += Number(i?.amount) || 0;
      });
      totalAmount += Number(packagingCost) || 0;

      // Balance Lock check (admin-defined)
      const lock = Number(party?.balanceLock || 0);
      if (lock > 0) {
        const current = Number(party?.runningChallanBalance || 0);
        const projected = current + Number(totalAmount || 0);
        if (projected > lock) {
          toast.error(
            `Balance locked for ${party?.name || "this account"}. Limit: ${lock}, Projected: ${Math.round(projected)}`,
            { position: "top-center", autoClose: 3000, theme: "light" }
          );
          return;
        }
      }

      const cleanedItems = items.map(({ packagingCost, ...rest }) => ({
        ...rest,
        taxPercent: 5,
        packagingTaxPercent: 5,
      }));

      let EditApi;
      if (source === "credit") {
        EditApi = UpdateCreditAPI;
      } else if (source === "debit") {
        EditApi = UpdateDebitAPI;
      } else {
        EditApi = UpdateChallanAPI;
      }
      const payload = {
        party,
        items: cleanedItems,
        amount: totalAmount,
        packagingCost: packagingCost != null && packagingCost !== "" ? Number(packagingCost) : undefined,
        packagingTaxPercent: 5,
        challanDate: challanDate ? moment(challanDate).toISOString() : (item?.createdAt ? moment(item.createdAt).toISOString() : undefined),
      };
      setIsSavingChallan(true);
      let res = await axios.patch(
        EditApi(item._id),
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (print) {
        showPrintModal(res.data);
        close();
      } else {
        close();
      }
    }
    catch (e) {
      if (e.response && e.response.status === 404) {
        console.log("Resource not found", e.response.data.error);
        toast.error(`${e.response.data.error}`, {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        console.log("saverr", e.response ? e.response.data : e.message);
        toast.error("Something went wrong, Please Contact Admin", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } finally {
      setIsSavingChallan(false);
    }
  }

  function _onAddRecord() {
    const normalizedCodeR = (codeR ?? "").toString().trim();
    const normalizedCodeL = (codeL ?? "").toString().trim();
    const hasPrescriptionData =
      String(nameR || "").trim() ||
      String(nameL || "").trim() ||
      String(rSph || "").trim() ||
      String(rCyl || "").trim() ||
      String(rAxis || "").trim() ||
      String(rAdd || "").trim() ||
      String(lSph || "").trim() ||
      String(lCyl || "").trim() ||
      String(lAxis || "").trim() ||
      String(lAdd || "").trim();

    if (
      party === null ||
      (!isPrescriptionOrderMode && !normalizedCodeR && !normalizedCodeL) ||
      (isPrescriptionOrderMode && !hasPrescriptionData) ||
      quantity === ""
    ) {
      toast.error("Please fill all the Fields", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    const qtyStr = String(quantity).trim();
    if (qtyStr.startsWith(".")) {
      toast.error("Quantity must not start with a decimal point (use 0.5 instead of .5)");
      return;
    }
    const qtyNum = Number(quantity);
    if (!Number.isFinite(qtyNum) || qtyNum < 0) {
      toast.error("Please enter a valid quantity (e.g. 0.5 or 1)");
      return;
    }

    let finalQuantity = quantity;
    let finalAmount = amount;
    if (reverseEntry) {
      finalQuantity = -Math.abs(Number(quantity));
      finalAmount = -Math.abs(Number(amount));
    }

    let data = {
      codeR: normalizedCodeR || null,
      codeL: normalizedCodeL || null,
      isPrescriptionOrder: Boolean(isPrescriptionOrderMode),
      nameR,
      nameL,
      brandR,
      brandL,
      quantity: finalQuantity,
      rateR,
      rSph,
      lSph,
      rCyl,
      lCyl,
      rAxis,
      lAxis,
      rAdd,
      lAdd,
      rateL,
      rate,
      discountAmount,
      discountPercent,
      fitting,
      fittingAmount,
      tint,
      arc,
      amount: finalAmount,
      packagingCost,
      orderRef,
      lProductCode,
      rProductCode,
      hsnCode,
      taxPercent: 5,
      packagingTaxPercent: 5,
      coating,
    };
    let copy = _.clone(items);
    copy.push(data);
    setItems(copy);
    setCodeR(null);
    setCodeL(null);
    setNameR("");
    setNameL("");
    setQuantity("");
    setRateL("");
    setRateR("");
    setRate("");
    setDiscountAmount("");
    setDiscountPercent(0);
    setFittingAmount("");
    setFitting("");
    setTint("");
    setArc("");
    setAmount("");
    setOrderRef("");
    setSelectR({});
    setSelectL({});
  }

  const setR = (data) => {
    setSelectR(data);
    if (data && data.code) {
      setCodeR(data.code);
      if (data.orderDetail) {
        setQuantity(data.quantity);
        setOrderRef(data.code);
        if (data.orderDetail.rSph !== undefined) setRsph(data.orderDetail.rSph);
        if (data.orderDetail.rCyl !== undefined) setRcyl(data.orderDetail.rCyl);
        if (data.orderDetail.rAxis !== undefined) setRaxis(data.orderDetail.rAxis);
        if (data.orderDetail.rAddition !== undefined) setRadd(data.orderDetail.rAddition);
        if (data.price !== undefined) setRateR(data.price);
        let productCode = "";
        if (data.orderType === "Fitting") {
          if (data.orderDetail.fitting) {
            setFitting(data.orderDetail.fitting);
            const fit = _.find(fittingMasters, { fittingType: data.orderDetail.fitting });
            if (fit) setFittingAmount(fit.amount);
          }
          if (data.orderDetail.rRate !== undefined) setRateR(data.orderDetail.rRate);
          productCode =
            data.orderDetail.rSph + "/" + data.orderDetail.rCyl + "/" + data.orderDetail.rAxis + "/" + data.orderDetail.rAddition;
          setNameR(
            [
              data.orderDetail.product?.index ?? data.orderDetail.fitter,
              data.orderDetail.productName ?? data.orderDetail.productNameR,
              data.orderDetail.product?.coating ?? data.orderDetail.fitting,
              productCode,
            ]
              .filter(Boolean)
              .join("-")
          );
        } else {
          productCode =
            data.orderDetail.rSph + "/" + data.orderDetail.rCyl + "/" + data.orderDetail.rAxis + "/" + data.orderDetail.rAddition;
          if (data.orderDetail.product) {
            setNameR(
              [
                data.orderDetail.product.index,
                data.orderDetail.product.productName,
                data.orderDetail.product.coating,
                productCode,
              ]
                .filter(Boolean)
                .join("-")
            );
            if (data.orderDetail.product.price !== undefined) setRateR(data.orderDetail.product.price);
            else if (data.rate !== undefined) setRateR(data.rate);
            setHsnCode(data.orderDetail.product.hsnCode);
            setTaxPercent(data.orderDetail.product.taxPercent);
          } else {
            setNameR((data.orderDetail.productName || "") + (productCode ? "-" + productCode : ""));
            if (data.rate !== undefined && data.price === undefined) setRateR(data.rate);
          }
        }
        setRProductCode(productCode);
        if (data.orderDetail.coat) setCoating(data.orderDetail.coat);
        setDiscountPercent(0);
      } else {
        afterSelectR(data.code);
      }
    }
  };
  const setL = (data) => {
    setSelectL(data);
    if (data && data.code) {
      setCodeL(data.code);
      if (data.orderDetail) {
        setQuantity(data.quantity);
        setOrderRef(data.code);
        if (data.orderDetail.lSph !== undefined) setLsph(data.orderDetail.lSph);
        if (data.orderDetail.lCyl !== undefined) setLcyl(data.orderDetail.lCyl);
        if (data.orderDetail.lAxis !== undefined) setLaxis(data.orderDetail.lAxis);
        if (data.orderDetail.lAddition !== undefined) setLadd(data.orderDetail.lAddition);
        if (data.price !== undefined) setRateL(data.price);
        let productCode = "";
        if (data.orderType === "Fitting") {
          if (data.orderDetail.fitting) {
            setFitting(data.orderDetail.fitting);
            const fit = _.find(fittingMasters, { fittingType: data.orderDetail.fitting });
            if (fit) setFittingAmount(fit.amount);
          }
          if (data.orderDetail.lRate !== undefined) setRateL(data.orderDetail.lRate);
          productCode =
            data.orderDetail.lSph + "/" + data.orderDetail.lCyl + "/" + data.orderDetail.lAxis + "/" + data.orderDetail.lAddition;
          setNameL(
            [
              data.orderDetail.product?.index ?? data.orderDetail.fitter,
              data.orderDetail.productName ?? data.orderDetail.productNameR,
              data.orderDetail.product?.coating ?? data.orderDetail.fitting,
              productCode,
            ]
              .filter(Boolean)
              .join("-")
          );
        } else {
          productCode =
            data.orderDetail.lSph + "/" + data.orderDetail.lCyl + "/" + data.orderDetail.lAxis + "/" + data.orderDetail.lAddition;
          if (data.orderDetail.product) {
            setNameL(
              [
                data.orderDetail.product.index,
                data.orderDetail.product.productName,
                data.orderDetail.product.coating,
                productCode,
              ]
                .filter(Boolean)
                .join("-")
            );
            if (data.orderDetail.product.price !== undefined) setRateL(data.orderDetail.product.price);
            else if (data.rate !== undefined) setRateL(data.rate);
            setHsnCode(data.orderDetail.product.hsnCode);
            setTaxPercent(data.orderDetail.product.taxPercent);
          } else {
            setNameL((data.orderDetail.productName || "") + (productCode ? "-" + productCode : ""));
            if (data.rate !== undefined && data.price === undefined) setRateL(data.rate);
          }
        }
        setLProductCode(productCode);
        if (data.orderDetail.coat) setCoating(data.orderDetail.coat);
      } else {
        afterSelectL(data.code);
      }
    }
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <h4 className={classes.cardTitleWhite}>Challan Edit</h4>
                <Box display={"flex"} alignItems={"center"}>
                  {orders.length > 0 && (
                    <Button
                      style={{ color: "white" }}
                      onClick={() => setOpenOrdersDialog(true)}
                    >
                      View Orders
                    </Button>
                  )}
                  <Button
                    style={{ color: "white" }}
                    onClick={() => setOpenColorsDialog(true)}
                  >
                    GET CODES
                  </Button>
                  <Button
                    style={{ color: "white" }}
                    onClick={() => {
                      const next = !isPrescriptionOrderMode;
                      setIsPrescriptionOrderMode(next);

                      // Switching modes should not keep stale selections/derived values.
                      setSelectR({});
                      setSelectL({});
                      setCodeR(null);
                      setCodeL(null);
                      cleanupCodeR();
                      cleanupCodeL();
                    }}
                  >
                    {isPrescriptionOrderMode ? "READY MASTER MODE" : "ADD PRESCRIPTION ORDER"}
                  </Button>
                  <Button style={{ color: "white" }} onClick={close}>
                    Close
                  </Button>
                  <Button style={{ color: "white" }} onClick={() => _onSave(false)} disabled={isSavingChallan}>
                    {isSavingChallan ? "Saving…" : "Save"}
                  </Button>
                  <Button style={{ color: "white" }} onClick={() => _onSave(true)} disabled={isSavingChallan}>
                    {isSavingChallan ? "Saving…" : "Save & Print"}
                  </Button>
                </Box>
              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={3} sm={3} md={2} style={{ marginTop: 25 }}>
                  <MuiPickersUtilsProvider utils={DateUtils}>
                    <DatePicker
                      label="Challan Date"
                      fullWidth
                      format="DD/MM/YYYY"
                      value={challanDate}
                      onChange={(date) => setChallanDate(date)}
                      animateYearScrolling
                    />
                  </MuiPickersUtilsProvider>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Autocomplete
                    className={classes.formControl}
                    options={users}
                    fullWidth
                    value={party}
                    onChange={(event, value) => setParty(value)}
                    getOptionLabel={(option) => option?.name || option?.accountName || ""}
                    id="party"
                    style={{ marginTop: 26 }}
                    renderInput={(params) => (
                      <TextField {...params} label="Party" />
                    )}
                  />
                </GridItem>
                {!isPrescriptionOrderMode && (
                  <GridItem xs={2} sm={2} md={2}>
                    {codeR && Object.keys(selectR)?.length > 0 ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          padding: "8px 0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginRight: 10,
                          }}
                        >
                          <CustomInput
                            labelText="Order Code R"
                            id="ordercodeR"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{ value: codeR, disabled: true }}
                          />
                        </div>
                        <Button
                          variant="contained"
                          size="small"
                          color="primary"
                          onClick={() => {
                            setCodeR(null);
                            setSelectR({});
                            cleanupCodeR();
                          }}
                          style={{ marginLeft: 10, marginTop: 30, height: 36 }}
                        >
                          X
                        </Button>
                      </div>
                    ) : (
                      <Autocomplete
                        loading={loadingCodesR}
                        className={classes.formControl}
                        options={codesR.slice(0, 200)}
                        fullWidth
                        filterOptions={filterOptions}
                        value={codeR}
                        onChange={(event, value) => {
                          setCodeR(value);
                          if (value) {
                            afterSelectR(value);
                          } else {
                            setSelectR({});
                            cleanupCodeR();
                          }
                        }}
                        onInputChange={(event, value) => {
                          debouncedEffect(value);
                        }}
                        getOptionLabel={(option) => option}
                        style={{ marginTop: 26 }}
                        id="codeR"
                        disabled={Object.keys(selectR)?.length > 0}
                        renderInput={(params) => (
                          <TextField {...params} label="Code R" />
                        )}
                      />
                    )}
                  </GridItem>
                )}
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText="Name R"
                    id="nameR"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: nameR,
                      ...(isPrescriptionOrderMode
                        ? { onChange: (e) => setNameR(e.target.value) }
                        : { readOnly: true }),
                    }}
                    disabled={!isPrescriptionOrderMode}
                  />
                </GridItem>
                {!isPrescriptionOrderMode && (
                  <GridItem xs={2} sm={2} md={2}>
                    {codeL && Object.keys(selectL)?.length > 0 ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          padding: "8px 0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginRight: 10,
                          }}
                        >
                          <CustomInput
                            labelText="Order Code L"
                            id="ordercodeL"
                            formControlProps={{ fullWidth: true }}
                            inputProps={{ value: codeL, disabled: true }}
                          />
                        </div>
                        <Button
                          variant="contained"
                          size="small"
                          color="primary"
                          onClick={() => {
                            setCodeL(null);
                            setSelectL({});
                            cleanupCodeL();
                          }}
                          style={{ marginLeft: 10, marginTop: 30, height: 36 }}
                        >
                          X
                        </Button>
                      </div>
                    ) : (
                      <Autocomplete
                        loading={loadingCodesL}
                        className={classes.formControl}
                        options={codesL.slice(0, 200)}
                        fullWidth
                        filterOptions={filterOptions}
                        value={codeL}
                        onChange={(event, value) => {
                          setCodeL(value);
                          if (value) {
                            afterSelectL(value);
                          } else {
                            setSelectL({});
                            cleanupCodeL();
                          }
                        }}
                        onInputChange={(event, value) => {
                          debouncedEffectL(value);
                        }}
                        getOptionLabel={(option) => option}
                        style={{ marginTop: 26 }}
                        id="codeL"
                        disabled={Object.keys(selectL)?.length > 0}
                        renderInput={(params) => (
                          <TextField {...params} label="Code L" />
                        )}
                      />
                    )}
                  </GridItem>
                )}
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText="Name L"
                    id="nameL"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: nameL,
                      ...(isPrescriptionOrderMode
                        ? { onChange: (e) => setNameL(e.target.value) }
                        : { readOnly: true }),
                    }}
                    disabled={!isPrescriptionOrderMode}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Quantity"
                    id="quantity"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: quantity,
                      onChange: (e) => {
                        const val = e.target.value;
                        const trimmed = String(val).trim();
                        if (trimmed !== "" && trimmed.startsWith(".")) {
                          toast.error("Quantity must not start with a decimal point (use 0.5 instead of .5)");
                          return;
                        }
                        setQuantity(val);
                      },
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Rate R"
                    id="rateR"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rateR,
                      onChange: (e) => setRateR(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Rate L"
                    id="rateL"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rateL,
                      onChange: (e) => setRateL(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Rate"
                    id="rate"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rate,
                      onChange: (e) => setRate(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Dis %"
                    id="discountPercent"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: discountPercent,
                      onChange: (e) => setDiscountPercent(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Dis Amt/Qty"
                    id="discountAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "number",
                      value: discountAmount,
                      onChange: (e) => setDiscountAmount(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <Autocomplete
                    loading={loadingFittingMasters}
                    className={classes.formControl}
                    options={fittingMastersCodes}
                    fullWidth
                    value={fitting}
                    onChange={(event, value) => setFitting(value)}
                    getOptionLabel={(option) => option}
                    style={{ marginTop: 26 }}
                    id="fitting"
                    renderInput={(params) => (
                      <TextField {...params} label="Fitting" />
                    )}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Fit Amt"
                    id="fittingAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: fittingAmount,
                      onChange: (e) => setFittingAmount(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Hsn Code"
                    id="hsnCode"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: hsnCode,
                      disabled: true,
                      onChange: (e) => setHsnCode(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Tax Percent"
                    id="taxPercent"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: taxPercent,
                      onChange: (e) => setTaxPercent(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Tint"
                    id="tint"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tint,
                      onChange: (e) => setTint(e.target.value),
                    }}
                  />
                </GridItem>
                {/* <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="ARC"
                    id="arc"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: arc,
                      onChange: (e) => setArc(e.target.value),
                    }}
                  />
                </GridItem> */}
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Amount"
                    id="amount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: amount,
                      onChange: (e) => setAmount(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Order Ref"
                    id="orderRef"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: orderRef,
                      onChange: (e) => setOrderRef(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={2}>
                  <CustomInput
                    labelText="Packaging tax Percent"
                    id="packagingTaxPercent"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: packagingTaxPercent,
                      onChange: (e) => setPackagingTaxPercent(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={2}>
                  <CustomInput
                    labelText="Packaging Cost"
                    id="packagingCost"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: packagingCost,
                      onChange: (e) => setPackagingCost(e.target.value),
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Total Qty"
                    id="totQuant"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled
                    inputProps={{
                      value: sumOfQuantities,
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Total Amt"
                    id="totAmt"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled
                    inputProps={{
                      value: Number(sumOfAmounts) + Number(packagingCost),
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={reverseEntry}
                        onChange={(e) => setReverseEntry(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="Reverse Entry"
                    style={{ marginTop: 26 }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <Fab
                    color="primary"
                    aria-label="add"
                    className={classes.fab}
                    onClick={_onAddRecord}
                  >
                    <AddIcon />
                  </Fab>
                </GridItem>
                {_.isEmpty(items) ? null : (
                  <GridItem xs={12}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={"center"}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {items.map((row, index) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.code}
                            >
                              {columns.map((column) => {
                                const value = row[column.id];
                                if (column.id === "action") {
                                  return (
                                    <TableCell align={"center"}>
                                      <Box
                                        display={"flex"}
                                        justifyContent={"center"}
                                      >
                                        <IconButton
                                          aria-label="delete"
                                          onClick={() => {
                                            let copy = _.clone(items);
                                            copy.splice(index, 1);
                                            setItems(copy);
                                          }}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Box>
                                    </TableCell>
                                  );
                                }
                                return (
                                  <TableCell key={column.id} align={"center"}>
                                    {value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </GridItem>
                )}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {openOrdersDialog && (
        <ChallanOrdersDialog
          open={openOrdersDialog}
          onClose={() => setOpenOrdersDialog(false)}
          data={orders}
          OnR={setR}
          OnL={setL}
        />
      )}

      {openColorsDialog && (
        <ColorsDialog
          open={openColorsDialog}
          onClose={() => setOpenColorsDialog(false)}
          data={readyMasterRange}
        />
      )}
    </Dialog>
  );
}
